import { useState, useEffect } from 'react';

interface HeroProps {
  reloadPage: () => void;
}

interface HeroData {
  logo_image: string;
  facebook_url: string;
  instagram_url: string;
}

export default function Hero({ reloadPage }: HeroProps) {
  const [data, setData] = useState<HeroData>({
    logo_image: '/Imagens/LOGO_MULATA.png',
    facebook_url: 'https://www.facebook.com/bolacha.mulata',
    instagram_url: 'https://www.instagram.com/bolacha.mulata/'
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch('https://mulata.wortik.com/bolacha-mulata/api/hero.php');
      const result = await response.json();
      if (result) {
        setData(result);
      }
    } catch (err) {
      console.error('Error loading hero data:', err);
    }
  };

  const getImageSrc = (path: string) => {
    if (path.startsWith('http')) {
      return path;
    }
    return path;
  };

  return (
    <>
      {/* Hero Section - Desktop */}
      <section 
        className="relative desktop-bg"
        style={{
          backgroundImage: 'url(https://i.imgur.com/Ee22rLM.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
          backgroundRepeat: 'no-repeat',
          width: '100%',
          paddingBottom: '57.29%',
          position: 'relative',
          height: 0,
          imageRendering: '-webkit-optimize-contrast'
        }}
      >
        {/* Logo - Desktop - 20% larger than original (20vw * 1.2 = 24vw) */}
        <div
          className="absolute animate-drop-in z-50"
          style={{
            top: '5%',
            left: '8%',
            width: '24vw',
            minWidth: '240px',
            maxWidth: '480px'
          }}
        >
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault();
              reloadPage();
            }}
            className="cursor-pointer block"
          >
            <img
              src={getImageSrc(data.logo_image)}
              alt="Bolacha Mulata"
              className="hover:scale-110 transition-transform duration-300"
              style={{
                width: '100%',
                height: 'auto',
                display: 'block'
              }}
              onError={(e) => {
                e.currentTarget.src = '/Imagens/LOGO_MULATA.png';
              }}
            />
          </a>
        </div>

        {/* Social Icons - Desktop - 20% smaller (2.5vw * 0.8 = 2vw), aligned with logo top */}
        <div 
          className="flex items-center absolute animate-drop-in z-50"
          style={{
            top: '5%',
            right: '11.98%',
            gap: '1.25vw',
            animationDelay: '0.2s'
          }}
        >
          <a
            href={data.facebook_url}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:scale-110 transition-transform duration-300"
            style={{
              width: '2vw',
              height: 'auto'
            }}
          >
            <img
              src="/Imagens/FB_ICON.png"
              alt="Facebook"
              style={{
                width: '100%',
                height: 'auto'
              }}
            />
          </a>
          <a
            href={data.instagram_url}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:scale-110 transition-transform duration-300"
            style={{
              width: '2vw',
              height: 'auto'
            }}
          >
            <img
              src="/Imagens/IG_ICON.png"
              alt="Instagram"
              style={{
                width: '100%',
                height: 'auto'
              }}
            />
          </a>
        </div>
      </section>

      {/* Hero Section - Mobile - 600x980px (163.33% ratio) - ONLY BACKGROUND CHANGE */}
      <section 
        className="relative mobile-bg"
        style={{
          backgroundImage: 'url(https://i.imgur.com/xAKIUGV.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
          backgroundRepeat: 'no-repeat',
          width: '100%',
          paddingBottom: '163.33%',
          position: 'relative',
          height: 0,
          imageRendering: '-webkit-optimize-contrast'
        }}
      >
        {/* Logo - Mobile - Lowered from 4% to 7% */}
        <div 
          className="absolute animate-drop-in z-50"
          style={{
            top: '7%',
            left: '3%',
            width: '62.92vw',
            minWidth: '189px',
            maxWidth: '315px'
          }}
        >
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault();
              reloadPage();
            }}
            className="cursor-pointer block"
          >
            <img
              src={getImageSrc(data.logo_image)}
              alt="Bolacha Mulata"
              className="hover:scale-110 transition-transform duration-300"
              style={{
                width: '100%',
                height: 'auto',
                display: 'block'
              }}
              onError={(e) => {
                e.currentTarget.src = '/Imagens/LOGO_MULATA.png';
              }}
            />
          </a>
        </div>
        
        {/* Social Icons - Mobile - Lowered from 6% to 9% */}
        <div 
          className="absolute animate-drop-in z-50"
          style={{
            top: '9%',
            right: '8%',
            animationDelay: '0.2s'
          }}
        >
          <div 
            className="flex flex-col items-center"
            style={{
              gap: '2.1vw'
            }}
          >
            <a
              href={data.instagram_url}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:scale-110 transition-transform duration-300"
              style={{
                width: '6.67vw',
                height: 'auto'
              }}
            >
              <img
                src="/Imagens/IG_ICON.png"
                alt="Instagram"
                style={{
                  width: '100%',
                  height: 'auto'
                }}
              />
            </a>
            <a
              href={data.facebook_url}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:scale-110 transition-transform duration-300"
              style={{
                width: '6.67vw',
                height: 'auto'
              }}
            >
              <img
                src="/Imagens/FB_ICON.png"
                alt="Facebook"
                style={{
                  width: '100%',
                  height: 'auto'
                }}
              />
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
